
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component, createRef } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Zergling from '../../../helpers/zergling';

class SearchinHeader extends Component {
    constructor (props) {
        super(props);
        this.referanc = createRef(null);
        this.inputElement = createRef();
        this.state = {
            value: "",
            data: null,
            loading: true,
            showSearchIcon: true
        };
        this.showSearch = this.showSearch.bind(this);
        this.dataMemoizing = this.dataMemoizing.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.requestGames = this.requestGames.bind(this);
    }
    showSearch () {
        if (this.state.showSearchIcon) {
            this.setState({
                showSearchIcon: false
            });
        } else {
            this.setState({
                showSearchIcon: true,
                data: null,
                loading: false
            });
        }
    }
    handleChange (value) {
        this.setState({value: value});
        if (value.length >= 3) {
            this.requestGames();
        } else if (value.length < 3) {
            this.setState({data: null, loading: true});
        }
    }
    dataMemoizing () {
        if (this.state.value.length < 3) {
            return;
        }
        this.setState({
            loading: false
        });
    }
    requestGames () {
        let request = {
            "source": "betting",
            "what": {
                "competition": ['name', 'id'],
                "game": ["id", "type", "start_ts", "team1_name", "team2_name", 'order', 'stat', 'info'],
                "region": ['name', 'alias', 'id'],
                "sport": ["id", "name", "alias", 'order', "type"]
            },
            "where": {
                'game': {
                    '@limit': 25,
                    '@or': [
                        {"team1_name": {"@like": {"eng": this.state.value}}},
                        {"team2_name": {"@like": {"eng": this.state.value}}}
                    ]
                }
            }
        };
        if (!isNaN(this.state.value)) {
            request = {
                "source": "betting",
                "what": {
                    "competition": ['name', 'id'],
                    "game": ["id", "type", "start_ts", "team1_name", "team2_name", 'order', 'stat', 'info'],
                    "region": ['name', 'alias', 'id'],
                    "sport": ["id", "name", "alias", 'order', 'type']
                },
                "where": {
                    'game': {
                        '@limit': 2,
                        'game_number': +this.state.value
                    }
                }
            };
        }
        Zergling.get(request).then(
            (response) => {
                this.setState({data: response, loading: false});
            });
    }
    componentDidMount () {
        document.addEventListener('mousedown', (e) => {
            if (this.referanc.current) {
                if (this.referanc.current.contains(e.target)) {
                    return;
                }
                this.setState({
                    loading: true
                });
            }
        });
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
SearchinHeader.propTypes = {
    type: PropTypes.string,
    onChange: PropTypes.func
};
export default connect()(SearchinHeader);